import TitleUi from '@components/common/TitleUi';
import { useEffect, useState, createRef } from 'react'
import styled from 'styled-components';
import HistoriaCard from './HistoriaCard';


const data = [
  {
    id: "01",
    videoUrl: "/videos/study.mp4",
    titulo: "Con Fondo Horizonte",
    descripcion: `Mis padres usaron esta herramienta y ahora
      cuento con el dinero para pagar mis estudios de postgrado.
      Seguiré su ejemplo de constancia para poder crecer profesionalmente.`
  },
  {
    id: "02",
    videoUrl: "/videos/house.mp4",
    titulo: "Una meta que pude cumplir",
    descripcion: `Invertí mis utilidades y ahorros durante
    algún tiempo con Fondo Horizonte, mientras aportaba
    ganaba rendimientos. Mi meta fue comprar la casa de 
    mis sueños.`
  },
  {
    id: "03",
    videoUrl: "/videos/bussiness.mp4",
    titulo: "Invertir, un hábito inteligente",
    descripcion: `El éxito está en invertir mientras sigues trabajando en tus proyectos. Las utilidades de mi negocio las invierto en GENESIS`
  }
];




const Historias = () => {

  const [elRefs, setElRefs] = useState([]);

  useEffect(() => {
    setElRefs(data.map((item, index) => ({ ...item, refference: createRef(index) })));
  }, []);

  const handlePlay = (id) => {
    const focus = elRefs.find(item => item.id === id);
    const video = focus && focus.refference && focus.refference.current || null;
    video && video.play();
  }
  const handlePause = (id) => {
    const focus = elRefs.find(item => item.id === id);
    const video = focus && focus.refference && focus.refference.current || null;
    video && video.pause();
  }

  return (

    <View>
      <TitleUi titulo="Historias de *personas *como *tú" />

      <HistoriaList>
        {elRefs.map(({ id, refference, videoUrl, titulo, descripcion }, index) => (
          <HistoriaCard
            key={id}
            handlePlay={() => handlePlay(id)}
            handlePause={() => handlePause(id)}
            refference={refference}
            videoUrl={videoUrl}
            titulo={titulo}
            descripcion={descripcion}
            loop={true}
          />
        ))}
      </HistoriaList>

    </View>
  );
}

export default Historias;

const View = styled.div`
  width:100%;
`;

const HistoriaList = styled.div`
  width:100%;
  display: flex;
  justify-content: center;
  flex-flow: wrap;
  gap: 1em;
`